import { injectPostgresEndpoints } from "./postgresApi";
import {
  PedaConversationRequest,
  PedaConversation,
  PedaEvaluationRequest,
  PedaEvaluationResponse,
} from "../../types/newtypes";

export const postgresPedaApi = injectPostgresEndpoints({
  endpoints: (builder) => ({
    getPedaConversation: builder.mutation<
      PedaConversation,
      PedaConversationRequest
    >({
      query: (params) => ({
        url: "/peda/conversation",
        method: "POST",
        body: params,
      }),
    }),
    evaluatePeda: builder.mutation<
      PedaEvaluationResponse,
      PedaEvaluationRequest
    >({
      query: (params) => ({
        url: "/peda/evaluate",
        method: "POST",
        body: params,
      }),
    }),
  }),
});

export const { useGetPedaConversationMutation, useEvaluatePedaMutation } = postgresPedaApi;
